import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";
import type { RenderCboxFn } from "~/features/orders/common/components/v2/QuoteTable/types";
import { QuoteGroup, LineNumberCell, QuoteCard, QuoteSection } from "./styled";
import { ProductHeader } from "./ProductHeader";
import { QuotePartsTable } from "./QuotePartsTable";

interface SimpleQuoteRowProps {
  quoteLine: QuoteLineMO;
  renderCheckbox: RenderCboxFn;
}

export const SimpleQuoteRow = ({ quoteLine, renderCheckbox }: SimpleQuoteRowProps) => {
  return (
    <QuoteGroup role="rowgroup">
      <LineNumberCell sx={{ pt: 2 }}>{quoteLine.lineNo}</LineNumberCell>
      <QuoteCard>
        <QuoteSection>
          <ProductHeader
            quoteLine={quoteLine}
            includeQuoteLine={quoteLine.parts.length < 2}
            renderCheckbox={renderCheckbox}
          />
          <QuotePartsTable quoteLine={quoteLine} renderCheckbox={renderCheckbox} sx={{ mb: "-1px" }} />
        </QuoteSection>
      </QuoteCard>
    </QuoteGroup>
  );
};
